import type { ApolloError } from "@apollo/client";
import type { GraphQLFormattedError } from "graphql";
import {
  AUTH_SESSION_FORCE_LOGOUT_CODES,
  type AuthSessionLogoutReason,
} from "shared/constants/authSession";

const collectErrorMessages = (
  graphQLErrors?: readonly GraphQLFormattedError[],
  networkError?: ApolloError["networkError"],
): string[] => {
  const messages: string[] = [];
  graphQLErrors?.forEach(error => {
    if (error.message) messages.push(error.message);
  });

  if (networkError) {
    if (networkError.message) messages.push(networkError.message);
    const result = (
      networkError as { result?: { errors?: GraphQLFormattedError[] } }
    ).result;
    result?.errors?.forEach(error => {
      if (error.message) messages.push(error.message);
      const code = error.extensions?.code;
      if (typeof code === "string") messages.push(code);
    });
  }

  return messages;
};

export const getAuthSessionForceLogoutReason = (
  graphQLErrors?: readonly GraphQLFormattedError[],
  networkError?: ApolloError["networkError"],
): AuthSessionLogoutReason | null => {
  const messages = collectErrorMessages(graphQLErrors, networkError);
  for (const code of AUTH_SESSION_FORCE_LOGOUT_CODES) {
    if (messages.some(message => message.includes(code))) {
      return code;
    }
  }
  return null;
};

export const getAuthSessionForceLogoutReasonFromApolloError = (
  error: ApolloError,
): AuthSessionLogoutReason | null =>
  getAuthSessionForceLogoutReason(error.graphQLErrors, error.networkError);
